import AutosaveStatus from './AutosaveStatus';
import EmbedPlayerStatus from './EmbedPlayerStatus';

export { AutosaveStatus, EmbedPlayerStatus };
export default { AutosaveStatus, EmbedPlayerStatus };
